import { useEffect, useRef } from 'react';
import { formatDate, getWeekName } from '../../../../lib/utils';

const CurrentWeek = ({
  currentWeeks,
  lastWeek,
  selectedDate,
  handleSelectDate,
}) => {
  const positionRef = useRef(null);

  useEffect(() => {
    if (positionRef.current) {
      positionRef.current.scrollTo({
        left: 500,
      });
    }
  }, []);

  return (
    <div
      ref={positionRef}
      className='flex gap-4 snap-x overflow-x-scroll scrollbar-hidden snap-mandatory bg-secondary rounded-lg'
    >
      {[lastWeek, currentWeeks].map((week, i) => (
        <div
          key={i}
          className='snap-always snap-center px-2 py-2 w-full shrink-0 grid grid-cols-7 gap-2'
        >
          {week.map((date, j) => (
            <button
              key={date}
              onClick={handleSelectDate(date)}
              className={`flex flex-col items-center py-1 px-1 rounded-md transition-colors ${
                date === formatDate(new Date())
                  ? 'ring-1 ring-neutral-700 bg-neutral-800 text-white'
                  : date === selectedDate
                  ? 'bg-white text-neutral-900'
                  : 'text-neutral-400 hover:bg-neutral-800'
              }`}
            >
              <span className='text-xs font-medium'>
                {getWeekName(j).slice(0, 3)}
              </span>
              <span className='text-sm mt-0.5'>{Number(date.slice(8))}</span>
            </button>
          ))}
        </div>
      ))}
    </div>
  );
};

export default CurrentWeek;
